import createSvgIcon from '../Utils/CreateSvgIcon';

export const Warning = createSvgIcon(
  <path
    d="M12 3L10.856 5.05913L3.11111 19L2 21H4.28792H19.7121H22L20.8889 19L13.144 5.05913L12 3ZM12 7.11825L5.39903 19H18.601L12 7.11825ZM11 15V11H13V15H11ZM11 16V18H13V16H11Z"
    fillRule="evenodd"
  />,
  'Warning',
);
